const doc = [({"en":({"js":({"nemoa":({"activities":({"show":({"index":({"overview":"Overview"})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;